import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeRange',
  standalone: false,
})
export class TimeRangePipe implements PipeTransform {
  moment = require('moment');

  transform(startDate: number | string, endDate?: number | string): any {
    let objDate = Object.create(null);
    objDate['years'] = 'г';
    objDate['months'] = 'мес';
    objDate['days'] = 'д';
    objDate['hours'] = 'ч';
    objDate['minutes'] = 'мин';

    let diffFormatted = [];
    let arrTemplate;
    const diff = this.moment.duration(this.moment(endDate || new Date()) - this.moment(startDate).valueOf())._data;

    for (let key in diff) {
      if (diff.hasOwnProperty(key) && ['hours', 'minutes', 'seconds'].indexOf(key) === -1 && !diff[key]) {
        delete diff[key];
      }
    }

    if (diff.years) {
      arrTemplate = ['years', 'months'];
    } else if (!diff.years && diff.months) {
      arrTemplate = ['months', 'days'];
    } else if (!diff.years && !diff.months && diff.days) {
      arrTemplate = ['days', 'hours'];
    } else if (!diff.years && !diff.months && !diff.days && diff.hours) {
      arrTemplate = ['hours', 'minutes'];
    } else {
      arrTemplate = ['minutes'];
    }

    arrTemplate.forEach((val) => {
      if (diff[val]) {
        diffFormatted.push(diff[val] + '' + objDate[val]);
      }
    });

    return diffFormatted.join(' ');
  }
}
